import React from "react";
import {
  Box,
  HStack,
  Icon,
  Progress,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FiCheckCircle, FiArrowRight } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useSurveyStatus } from "../../dashboard/hooks/useSurveyStatus";

export function ProfileCompletenessNudge({ onStartSurvey }) {
  const { t } = useTranslation("common");
  const { status, loading } = useSurveyStatus();

  if (loading || !status) return null;

  const modules = (status.available_surveys || []).filter((s) => s.kind === "module");
  if (modules.length === 0) return null;

  const totalModules = modules.length;
  const completedModules = 0;
  const pct = totalModules > 0 ? Math.round((completedModules / (completedModules + totalModules)) * 100) : 100;

  return (
    <Box
      bg="white"
      borderRadius="md"
      boxShadow="sm"
      borderLeft="3px solid"
      borderLeftColor="gwbi.500"
      p={4}
    >
      <VStack align="stretch" spacing={3}>
        <Text fontWeight="bold" fontSize="sm" color="gray.800">
          {t("profile_nudge.title", "Complete your professional profile")}
        </Text>
        <HStack justify="space-between">
          <Text fontSize="xs" color="gray.500">
            {t("profile_nudge.progress", "{{pct}}% complete", { pct })}
          </Text>
          <Text fontSize="xs" color="gray.500">{completedModules}/{completedModules + totalModules}</Text>
        </HStack>
        <Progress value={pct} size="xs" colorScheme="gwbi" borderRadius="full" />
        <VStack align="stretch" spacing={2}>
          {modules.slice(0, 3).map((m) => (
            <HStack
              key={m.code}
              as="button"
              onClick={() => onStartSurvey?.(m.code)}
              justify="space-between"
              p={2}
              borderRadius="md"
              _hover={{ bg: "gray.50" }}
              transition="all 0.15s"
            >
              <HStack>
                <Icon as={FiCheckCircle} color="gray.300" boxSize={4} />
                <Text fontSize="sm" color="gray.700">{m.title}</Text>
              </HStack>
              <HStack spacing={1}>
                <Text fontSize="xs" color="gray.400">~{m.estimated_minutes} min</Text>
                <Icon as={FiArrowRight} color="gray.400" boxSize={3} />
              </HStack>
            </HStack>
          ))}
        </VStack>
      </VStack>
    </Box>
  );
}
